import React from "react";

const LandingFrame = () => {
  return (
    <>
    
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="https://ludoking.com/play/"
        title="Ludo King Play"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        allow="fullscreen"
      />
    </div>
    </>
  );
};

export default LandingFrame;
